<div class="externalContainer">
    
    <div class="loginHeader">
        <div class="logoContainer">
            <div><img class="logo" [src]="logo" /></div>
            <div><img *ngIf="logo2" class="logo2" [src]="logo2" /></div>
            <div><img *ngIf="logo3" class="logo3" [src]="logo3" /></div>
        </div>

        <app-language-selector class="loginLanguageSelector"></app-language-selector>
    </div>

    <div *ngIf="login" class="loginCard">



        <div class="titleGroup">
            <div class="title1">{{ "general.warrantyService" | transloco }}</div>
            <div class="title2">{{ "login.title2" | transloco }}</div>
        </div>

        <form [formGroup]="formLogin" class="loginForm">
            <div class="inputLoginGroup">
                <mat-label class="labelLogin">{{ "login.username" | transloco }} <mat-icon>person</mat-icon></mat-label>
                <input class="inputLogin" matInput name="email" type="email" formControlName="email" maxlength="200"
                    autocomplete="username" [placeholder]="'login.usernamePlaceholder' | transloco" />
            </div>

            <div class="inputLoginGroup" style="margin-top: 54px;">
                <mat-label class="labelLogin">{{ "login.password" | transloco }} <mat-icon>lock</mat-icon></mat-label>
                <input class="inputLogin" matInput name="password" type="password" formControlName="password" maxlength="200" [placeholder]="'login.passwordPlaceholder' | transloco" />
            </div>
        </form>
        <div class="buttonsGroup1">
            <button style="border: 1px solid gray;" class="buttonOnlyText" (click)="cambiarVista('recuperar')">
                {{ "login.forgotPassword" | transloco }}
            </button>
            <button style="border: 1px solid gray;" class="buttonOnlyText" (click)="navigateToRegister()">{{ "login.register" | transloco }}</button>
        </div>

        <div style="display:flex; flex-direction: column; width: 100%; align-items: center; justify-content: center;">
            <button class="buttonLogin" (click)="acceder()">{{ "login.button" | transloco }}</button>
            <button style="border: 1px solid gray;" class="buttonOnlyText" (click)="navigateToSinRegister()">
                {{ "login.createIssue" | transloco }}
            </button>
        </div>

        <!-- <div style="display:flex; width: 100%; align-items: center; justify-content: center; gap:12px">
            <button class="buttonGoogle"><img src="../../../../assets/bergara/icon-google.png"
                style="margin-right: 8px;" />Google</button>
            <button class="buttonApple"><img src="../../../../assets/bergara/icon-apple.png" style="margin-bottom: 3px; margin-left: 1px;"/></button>
            <button class="buttonMicrosoft"><img src="../../../../assets/bergara/icon-microsoft.png"
                    style="margin-right: 8px;" />Microsoft</button>
        </div> -->
    </div>

    <div *ngIf="recuperarPass" class="recuperarCard">

        <div class="titleGroup2" *ngIf="stepChangePassword === 1">
            <div class="title1">{{ "recoverPassword.title1" | transloco }}</div>
            <div class="title2">{{ "recoverPassword.title2" | transloco }}</div>
        </div>

        <div class="titleGroup2" *ngIf="stepChangePassword === 2" style="margin-bottom: 20px;">
            <div class="title1">{{ "recoverPassword.title1" | transloco }}</div>
            <div class="title2">{{ "recoverPassword.title2Code" | transloco }}</div>
        </div>

        <div class="titleGroup2" *ngIf="stepChangePassword === 3" style="margin-bottom: 20px;">
            <div class="title1">{{ "recoverPassword.title1" | transloco }}</div>
            <div class="title2">{{ "recoverPassword.title2NewPassword" | transloco }}</div>
        </div>

        <div class="titleGroup2" *ngIf="stepChangePassword === 4" style="margin-bottom: 20px;">
            <div class="title1">{{ "recoverPassword.title1" | transloco }}</div>
            <div class="title2">{{ "recoverPassword.title2Success" | transloco }}</div>
        </div>

        <form [formGroup]="formRecuperarPass" class="loginForm" *ngIf="stepChangePassword === 1">
            <mat-form-field appearance="outline">
                <mat-label>{{ "recoverPassword.inputLabel" | transloco }}</mat-label>
                <input matInput name="email" type="email" formControlName="email" maxlength="200"
                    autocomplete="email" [placeholder]="'recoverPassword.emailPlaceholder' | transloco" (blur)="comprobarEmail()"/>
            </mat-form-field>
        </form>

        <form [formGroup]="formCodigoActivacion" class="loginForm" *ngIf="stepChangePassword === 2">
            <mat-form-field appearance="outline" style="margin-bottom: 20px;">
                <mat-label>{{ "recoverPassword.activationCode" | transloco }}</mat-label>
                <input matInput name="codigo" type="text" formControlName="codigo" maxlength="5"
                    [placeholder]="'recoverPassword.activationCodePlaceholder' | transloco"/>
            </mat-form-field>
            
            <div *ngIf="errorCodigo" class="error-message" style="color: red; margin-bottom: 20px;">
                {{ errorCodigo }}
            </div>
        </form>

        <form [formGroup]="formNuevaContrasena" class="loginForm" *ngIf="stepChangePassword === 3">
            <mat-form-field appearance="outline" style="margin-bottom: 20px;">
                <mat-label>{{ "recoverPassword.newPassword" | transloco }}</mat-label>
                <input matInput name="newPassword" type="password" formControlName="newPassword" maxlength="200"
                    [placeholder]="'recoverPassword.newPasswordPlaceholder' | transloco"/>
                <mat-error *ngIf="formNuevaContrasena.get('newPassword')?.hasError('required')">
                    {{ "recoverPassword.newPassword" | transloco }} es requerido
                </mat-error>
                <mat-error *ngIf="formNuevaContrasena.get('newPassword')?.hasError('minlength')">
                    La contraseña debe tener al menos 8 caracteres
                </mat-error>
                <mat-error *ngIf="formNuevaContrasena.get('newPassword')?.hasError('maxlength')">
                    La contraseña no puede tener más de 200 caracteres
                </mat-error>
            </mat-form-field>
            
            <mat-form-field appearance="outline" style="margin-bottom: 20px;">
                <mat-label>{{ "recoverPassword.confirmPassword" | transloco }}</mat-label>
                <input matInput name="confirmPassword" type="password" formControlName="confirmPassword" maxlength="200"
                    [placeholder]="'recoverPassword.confirmPasswordPlaceholder' | transloco"/>
                <mat-error *ngIf="formNuevaContrasena.get('confirmPassword')?.hasError('required')">
                    {{ "recoverPassword.confirmPassword" | transloco }} es requerido
                </mat-error>
                <mat-error *ngIf="formNuevaContrasena.get('confirmPassword')?.hasError('minlength')">
                    La confirmación de contraseña debe tener al menos 8 caracteres
                </mat-error>
                <mat-error *ngIf="formNuevaContrasena.get('confirmPassword')?.hasError('maxlength')">
                    La confirmación de contraseña no puede tener más de 200 caracteres
                </mat-error>
            </mat-form-field>
            
            <div *ngIf="errorCodigo" class="error-message" style="color: red; margin-bottom: 20px;">
                {{ errorCodigo }}
            </div>
        </form>

        <div class="buttonsGroupRecuperar">
            <button class="buttonLogin" [disabled]="!validEmail" (click)="enviarCorreoCambioContrasena()" *ngIf="stepChangePassword === 1">
                {{ "recoverPassword.submit" | transloco }}
            </button>
            <button class="buttonLogin" [disabled]="!formCodigoActivacion.valid" (click)="verificarCodigo()" *ngIf="stepChangePassword === 2">
                {{ "recoverPassword.verifyCode" | transloco }}
            </button>
            <button class="buttonSecondary" (click)="reenviarCodigoCambioPassword()" *ngIf="stepChangePassword === 2">
                {{ "recoverPassword.resendCode" | transloco }}
            </button>
            <button class="buttonLogin" [disabled]="!formNuevaContrasena.valid" (click)="cambiarPassword()" *ngIf="stepChangePassword === 3">
                {{ "recoverPassword.changePassword" | transloco }}
            </button>
            <button class="buttonLogin" (click)="cambiarVista('login')" *ngIf="stepChangePassword === 4">
                {{ "recoverPassword.returnToLogin" | transloco }}
            </button>
            <button class="buttonLogin" (click)="cambiarVista('login')" *ngIf="stepChangePassword === 1">
                {{ "general.back" | transloco }}
            </button>
        </div>
    </div>

    <div *ngIf="!recuperarPass" class="footer">
        Copyright © {{ getCurrentYear() }} <a style="margin-left: 10px;" href="/aviso-legal">{{ "login.legalWarning" | transloco }}</a> <a style="margin-left: 10px;" href="/politica-cookies">{{ "login.cookiesPolicy" | transloco }}</a> 
    </div>
</div>